export { default } from './CopyClipboard';
export * from './CopyToClipboard.types';
